import React from "react";
import { classnames, Element, SLATE_NODE_PLACEHOLDER_CLASSNAME } from "..";
import { BlockRenderer } from "./BlockRenderer";

export const SlateNodePlaceholder = ({ node }: { node: Element }) => {
  return (
    <BlockRenderer
      node={
        {
          ...node,
          attributes: {
            ...node.attributes,
            "css-class": classnames(
              node.attributes["css-class"],
              SLATE_NODE_PLACEHOLDER_CLASSNAME
            ),
          },
        } as any
      }
    />
  );
};
